<template lang="pug">
EditDealTab(id="deal")
  EditDealTabSection(:full-width="false")
    template(v-slot:header)
      h2 Deal
    template(v-slot:body)
      .deal-tab-fields
        BriqInput(label="Key" :value="deal.Key" disabled hideOptionalMarker)
        .some-space
          // todo: unify this with briq checkbox
          // adding the label like this in order to match UI
          label Availability of deal*
          BriqCheckboxStandalone(label="Active" v-model="deal.Enabled" :disabled="disabled" data-test-id="availability-of-deal-active-checkbox")
        BriqRadio(
          v-if="showDealAvailbilityButtons"
          :options="availabilityOfDealOptions"
          v-model="availability"
          :disabled="disabled"
          :required="true"
          :dense="true"
          :border="true"
          )
        BriqInput(
          data-test-id="internal-name"
          label="Name"
          v-model="deal.InternalName"
          :required="true"
          :disabled="disabled"
          :error="nameError"
          )
        BriqInput(
          data-test-id="position"
          label="Position"
          v-model="deal.Position"
          type="number"
          step="0.1"
          help="Can be used to sort deals in the admin selection dropdowns. The deal with the lowest number appears on top."
          :disabled="disabled"
          )
        // todo: integer price should get two decimals after comma
        BriqInput(
          :label="dealPriceLabel"
          :value="dealPrice"
          :prepend="deal.PriceIsStartingPrice ? 'from' : null"
          placeholder="0,00"
          type="number"
          step="0.01"
          readonly
          hideOptionalMarker
          )
        BriqInput(
          data-test-id="minVisitors"
          label="Min. visitors"
          v-model="deal.MinPersons"
          placeholder="1"
          type="number"
          :error="minPersonsError"
          step="1"
          min="0"
          :disabled="disabled"
          )
        BriqInput(
          data-test-id="maxVisitors"
          label="Max. visitors"
          v-model="deal.MaxPersons"
          placeholder="1"
          type="number"
          step="1"
          min="0"
          :disabled="disabled"
          )
  EditDealTabSection(:full-width="false")
    template(v-slot:title) Availability
    template(v-slot:body)
      DealAvailability(:deal="deal")
</template>

<script>
import EditDealTab from '@/vue/inventory/deals/edit/EditDealTab.vue'
import EditDealTabSection from '@/vue/inventory/deals/edit/EditDealTabSection.vue'
import DealAvailability from '@v/inventory/deals/edit/tab-deal/DealAvailability.vue'

export default {
  name: 'DealTab',
  components: { EditDealTab, EditDealTabSection, DealAvailability },
  inject: ['validations'],
  props: {
    deal: { type: Object, required: true },
    disabled: Boolean,
  },
  data() {
    return {
      showDealAvailbilityButtons: false,
      availability: '',
      availabilityOfDealOptions: {
        onlyBookableInBriqApp: 'Only bookable in briq.app',
        bookableButHidden:
          'Bookable in shop but deal is hidden in overview, only bookable via direct links',
        bookableAndShown: 'Bookable in shop, and shown in overview',
      },
    }
  },
  watch: {
    dealActive(newVal) {
      this.showDealAvailbilityButtons = newVal
      if (!newVal) {
        this.availability = 'onlyBookableInBriqApp'
        this.deal.AvailableOnline = false
        this.deal.ListInFunnel = false
      }
    },
    availability(newVal) {
      this.deal.AvailableOnline = newVal === 'onlyBookableInBriqApp' ? false : true
      this.deal.ListInFunnel = newVal === 'bookableAndShown' ? true : false
    },
  },
  methods: {
    preselectDealAvailability() {
      if (!this.deal.AvailableOnline && !this.deal.ListInFunnel)
        this.availability = 'onlyBookableInBriqApp'

      if (this.deal.AvailableOnline && !this.deal.ListInFunnel)
        this.availability = 'bookableButHidden'

      if (this.deal.AvailableOnline && this.deal.ListInFunnel)
        this.availability = 'bookableAndShown'
    },
  },
  computed: {
    dealPriceLabel() {
      const incExcTaxLabel = this.deal.Price.DisplayIncludingTax
        ? '(including tax)'
        : '(excluding tax)'
      return `Price per person ${incExcTaxLabel}`
    },
    dealPrice() {
      const dealPrice = this.deal.Price
      return dealPrice.DisplayIncludingTax ? dealPrice.IncludingTax : dealPrice.ExcludingTax
    },
    nameError() {
      return (
        (this.validations.$dirty &&
          this.validations.deal.InternalName.$invalid &&
          'Name is required') ||
        null
      )
    },
    minPersonsError() {
      return (
        (this.validations.$dirty &&
          this.validations.deal.MinPersons.$invalid &&
          'Min. visitors must be lower than Max. visitors') ||
        null
      )
    },
    dealActive() {
      return this.deal.Enabled
    },
  },
  mounted() {
    this.showDealAvailbilityButtons = this.dealActive
    this.preselectDealAvailability()
  },
}
</script>

<style lang="stylus">
@import '~@v/variables.styl'

.deal-tab-fields .briq-form-element
  margin-bottom space-S
</style>

<style lang="stylus" scoped>
@import '~@v/variables.styl'

.some-space
  margin-bottom space-XXS
</style>
